import React, { useContext } from "react";

import styles from "./MealItem.module.css";
import MealItemForm from "./MealItemForm";

import CartContext from "../../../store/Cart-context";

function MealItem(props) {
  const CartCtx = useContext(CartContext);

  const price = `$${props.price.toFixed(2)}`;

  function addtocart(amount) {
    CartCtx.addItem({
      id: props.id,
      name: props.name,
      amount: amount,
      price: props.price,
    });
  }

  return (
    <li className={styles.meal}>
      <div>
        <h3>{props.name}</h3>
        <div className={styles.description}> {props.description}</div>
        <div className={styles.price}>{price}</div>
      </div>
      <div>
        <MealItemForm onAddToCart={addtocart} id={props.id} />
      </div>
    </li>
  );
}

export default MealItem;
